import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import SummaryOfReportedEvents from './SummaryEvents';
import AppInfo from './AppInfo';
import AppActions from './AppActions';

import { APP_TYPE_HEADERS } from '@constants/individualPortal/dashboard/dashboardModelTypes';
import { getPrimaryMember } from '@utils/dashboard/processCommon';
import { formatToLocale } from '@utils/dates/dateMethods';


const ApplicationPanel = (props) => {
    const {
        envData,
        latestApp,
        appPanelData,
        appPanelData: {
            householdCaseId,
            applicationStatus,
            applicationType,
            applicants,
            caseNumber,
            encryptedCaseNumber,
            applicationYear,
            createdDate,
            applicationDentalStatus
        },
        onCancelApp
    } = props;

    const primaryMember = getPrimaryMember(applicants);

    const appInfo = { ...appPanelData, applicationType: APP_TYPE_HEADERS[applicationType], primaryMember };
    const appActionsData = { householdCaseId, applicationStatus, caseNumber, encryptedCaseNumber, applicationYear, onCancelApp, applicationDentalStatus };
    const appPanelHeader = envData && envData.isState && envData.isState.MN ? <FormattedMessage id={APP_TYPE_HEADERS[applicationType]}/> :
        <Fragment>
            {applicationYear} <FormattedMessage id={APP_TYPE_HEADERS[applicationType]}/> <FormattedMessage id='common.application_dated'/> {formatToLocale(createdDate, envData.language)}
        </Fragment>;

    return (
        <div className='gi-panel gi-application-panel application'>
            <h4>{ appPanelHeader }</h4>
            <AppInfo data={appInfo} envData={envData}/>
            <AppActions data={appActionsData} latestApp={latestApp} envData={envData} />
            <SummaryOfReportedEvents applicants={applicants} latestApp={latestApp} envData={envData}/>
        </div>
    );
};

export default ApplicationPanel;